import { Popover as ChakraPopover, PopoverProps as ChakraPopoverProps } from '@chakra-ui/react';
import React from 'react';

export type PopoverProps = ChakraPopoverProps;

/**
 * This component currently can only support light mode.
 *
 * When trying to override the default styles for the Popover
 * the colorMode is not getting injected correctly to the theme
 * that is used for Popover.
 *
 * This currently seems to be an issue with Chakra UI itself.
 */
export default function Popover(props: ChakraPopoverProps): React.ReactElement {
  return <ChakraPopover {...props} />;
}
